import { loadingAsyncState } from "widgets-for-react";
import { EventsApiClient } from "../../../backendApi/events.generated";
const eventsApiClient = new EventsApiClient(window.location.origin);
export const initialActivitySelectionBlockState = (props)=>{
    return {
        events: loadingAsyncState(async ()=>{
            const details = await eventsApiClient.getDetailsByIds(props.field_activiteiten.map((activity)=>activity.option_key).toArray());
            return {
                kind: "result",
                status: 200,
                value: details.Result
            };
        })
    };
};
